import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useApi from '../api/base/useApi';
import useAnonymousMode from '../iframe/useAnonymousMode';
import { stripeBilling } from '@iblai/ibl-web-react-common';
import {
  getDayJSDurationObjFromSeconds,
  getTimeDifferenceBetweenTwoDates,
} from '../../utils/shared';
import dayjs from 'dayjs';
export default function useSubscriptionStatus() {
  const [show, setShow] = useState(false);
  const [subscriptionExtraData, setSubscriptionExtraData] = useState({
    active: false,
    trial_ends: null,
  });
  const [tooltip, setTooltip] = useState(
    `Your subscription is currently inactive. You need to renew or update your payment details`
  );
  const [pillDisplay, setPillDisplay] = useState(`Update`);
  const [description, setDescription] = useState(
    `Your subscription is currently inactive. You need to renew or update your payment details`
  );
  const [loading, setLoading] = useState(false);
  const [customerPortalURL, setCustomerPortalURL] = useState('');
  const [app, setApp] = useState(null);
  const auth = useSelector((state) => state.auth.data);
  const api = useApi();
  const anonymous = useAnonymousMode();

  const loadSubscriptionsStatus = async () => {
    const url = `/api/features/apps/`;
    const dmToken = localStorage.getItem('dm_token');
    const response = await api.get(url, { app: 'mentor' }, dmToken);
    if (response?.data) {
      const mentorApp = response?.data?.results?.find(
        (item) =>
          item?.app?.name?.toLowerCase()?.includes('mentor') &&
          item?.platform?.key === auth.tenant.key
      );
      if (mentorApp) {
        setApp(mentorApp);
        setSubscriptionExtraData({
          active: mentorApp?.subscription?.active,
          trial_ends: mentorApp?.subscription?.trial_ends,
        });
        if (
          !(
            mentorApp?.subscription?.active &&
            mentorApp?.subscription?.trial_ends
          )
        ) {
          return;
        }
        const timeRemaining = getTimeDifferenceBetweenTwoDates(
          mentorApp?.subscription?.trial_ends,
          dayjs()
        );
        await stripeBilling(
          {
            return_url: new URL(window.location.href),
            //callback: 'createCustomerPortalURL',
          },
          (url) => {
            setShow(true);
            if (timeRemaining > 0) {
              const durationObj = getDayJSDurationObjFromSeconds(timeRemaining);
              let timeRemainingInString = '';
              if (timeRemaining >= 3600 * 24) {
                timeRemainingInString = `${Math.round(durationObj.asDays())} days`;
              } else if (timeRemaining > 3600) {
                timeRemainingInString = `${Math.round(durationObj.asHours())} hours`;
              } else {
                timeRemainingInString = `${Math.round(durationObj.asMinutes())} minutes`;
              }
              const tooltipValue = `You’re on a free trial for the next ${timeRemainingInString}. Upgrade to a paid plan 💪`;
              setDescription(tooltipValue);
              setTooltip(tooltipValue);
              setPillDisplay('Subscribe');
              setCustomerPortalURL(url);
            } else {
              //TODO have a modal here instead of pure redirect
              window.location.href = url;
            }
          }
        );
        /*if (
          !mentorApp?.has_active_subscription &&
          auth?.tenant?.key !== 'main'
        ) {
          setShow(true);
        }*/
      } else if (auth?.tenant?.key === 'main') {
        await handleStartFreeTrial();
      }
    }
  };

  const handleStartFreeTrial = async () => {
    const url = `/api/features/apps/update-trial-status/`;
    const payload = {
      app: process.env.REACT_APP_IBL_MENTOR_URL,
      free_trial_started: true,
      platform: auth?.tenant?.key,
    };
    const response = await api.post(
      url,
      payload,
      false,
      localStorage.getItem('dm_token')
    );
    if (response?.data) {
    }
  };

  const handleGotoPaymentUpdate = async () => {
    if (app?.app?.url?.startsWith('mentor.')) {
      if (app?.subscription?.status === 'canceled') {
        handleRenewSubscription();
        return;
      }

      const url = `/api/service/orgs/main/users/${auth?.user?.user_nicename}/stripe/customer-portal/`;
      const response = await api.get(url);
      if (response?.data) {
        window.location.assign(response?.data?.url);
      }
    } else {
      window.location.assign(app?.app?.url);
    }
  };

  const handleRenewSubscription = async () => {
    const url = `/api/service/orgs/main/users/${auth?.user?.user_nicename}/stripe/subscription-renewal/`;
    const payload = {
      checkout_session_uuid: app?.subscription?.identifier,
    };
    const response = await api.post(url, payload);
    if (response?.data) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (
      process.env.REACT_APP_IBL_ENABLE_STRIPE === 'true' &&
      !loading &&
      !anonymous
    ) {
      loadSubscriptionsStatus();
    }
  }, []);

  return {
    show,
    handleGotoPaymentUpdate,
    subscriptionExtraData,
    tooltip,
    description,
    pillDisplay,
    customerPortalURL,
  };
}
